export const ACTION_PREFIX = 'BANK_LINK';

export const actionTypes = {
  UPDATE_SEND_SMS_FOR_BANK_CONFIRMATION: 'UPDATE_SEND_SMS_FOR_BANK_CONFIRMATION',
  UPDATE_CAN_RESEND_SMS_FOR_BANKLINK: 'UPDATE_CAN_RESEND_SMS_FOR_BANKLINK',
};
